import { useTranslation } from "react-i18next";
import { ElementGroupRowCountProps } from "./types";

export const ElementGroupRowCount = ({ count }: ElementGroupRowCountProps) => {
  const { t } = useTranslation();

  return (
    <span className="text-gray-500 flex-shrink-0">
      {t("smartSurveyor.elementGroups.rowCount", { count })}
    </span>
  );
};
